export default (obj) =>  { return {... obj}}
